import { Dispatch } from 'redux'

import anchor from '../../../constants/anchor'
import { apiInstance } from '../../api/apiInstance'
import { RootState } from '../../store/rootReducer'

export type MarketplaceDesc = {
    prefix: string
    suffix: string
    order: string[]
}

const getMarketplaceDesc = (marketplace: string) => async (
    _dispatch: Dispatch,
    getState: () => RootState,
): Promise<MarketplaceDesc | null> => {
    const { userData } = getState()
    const params = {
        userId: userData.smsAuth.userId,
        marketplace,
    }
    const config = {
        headers: {
            Authorization: `${anchor} ${localStorage.getItem('accessToken')}`
        }
    }
    try {
        const { data: { status, data } } = await apiInstance.post('/sales/marketplaces/getMarketplaceDesc', params, config)
        if (status === 'ok' && data) {
            return {
                prefix: data.prefix || '',
                suffix: data.suffix || '',
                order: Array.isArray(data.order) ? data.order : [],
            }
        }
    } catch (e) {
        console.error('get marketplace description failed', e)
    }
    return null
}

export default getMarketplaceDesc
